/**
 * Top-level keys in GET /notify/notification_center response.
 * Each value is an array of row objects (see API docs in slice).
 */
export const NOTIFICATION_CENTER_TAB_KEYS = [
  "reporting",
  "messages",
  "cases",
  "charge_invoices",
  "product",
  "settings",
  "deadlines",
];
